import { loadable } from '../../components/loadable';

export const LoadablePortalSubscriptionPage = loadable(
  () => import('./PortalSubscriptionPage'),
  { key: 'HotConnectedPortalSubscriptionPage' }
);
